import del_icon from "../../../assets/cancel_icn.png";
import AudioPlayer from "../audioWrap/AudioPreview";
import "./styles.css";

/**
 * Component for rendering a file preview, supporting different types such as images, audio, etc.
 *
 * @component
 * @param {Object} props - Component props.
 * @param {File | Blob} props.itm - The file or blob to preview.
 * @param {function} props.handleFileDelete - Function to handle file deletion.
 * @param {number} props.idx - Index of the file in the list.
 * @param {boolean} props.isDisabled - Flag indicating if the file is disabled or not.
 * @param {string} props.type - Type of the file preview (e.g., "camera", "file", "audio").
 * @returns {JSX.Element} - Rendered component.
 */
const FilePreview = ({ itm, handleFileDelete, idx, isDisabled, type }) => {
  /**
   * Handles the redo click event for the file preview.
   */
  const handleRedoClick = () => {
    handleFileDelete(idx);
  };
  return (
    <>
      {(type === "camera" || type === "file") && (
        <div className="filePreview">
          <div className="image-container">
            <img
              src={URL.createObjectURL(itm.file)}
              alt="Base64 Image"
              style={{ width: `50px`, height: `50px` }}
            />
            {handleFileDelete && !isDisabled && (
              <img
                className="filePreview_itm_icon"
                src={del_icon}
                alt="filePreview_itm_icon"
                onClick={() => handleFileDelete(idx)}
              />
            )}
          </div>
        </div>
      )}
      
      {type === "audio" && (
        <AudioPlayer
          audioFile={URL.createObjectURL(itm.file)}
          duration={itm.metadata?.duration}
          redoFunction={handleRedoClick}
          showSave={false}
          showControl={true}
          handleSave={"null"}
          sliderColor={"success"}
        />
      )}

      {(type === "video") && (
        <div className="filePreview">
          <div className="image-container">
            <video
              src={URL.createObjectURL(itm.file)}
              controls
              style={{display:"block",width: `65px`, height: `65px` }}
            />
            {handleFileDelete && !isDisabled && (
              <img
                className="filePreview_itm_icon"
                src={del_icon}
                alt="filePreview_itm_icon"
                onClick={() => handleFileDelete(idx)}
              />
            )}
          </div>
        </div>
      )}
    </>
  );
};

export { FilePreview };
